// /units and /units/<id>: the in-game loop plays only while it's on screen
// (never with reduced motion), and the anatomy figure loads when it nears the
// viewport, in the viewer's color scheme, sized to its own height.

const reduce = matchMedia("(prefers-reduced-motion: reduce)");
const light = matchMedia("(prefers-color-scheme: light)");

function clips(): void {
	const videos = document.querySelectorAll<HTMLVideoElement>(
		"video[data-autoplay]",
	);
	if (!videos.length || !("IntersectionObserver" in window)) return;
	const io = new IntersectionObserver(
		(entries) => {
			for (const e of entries) {
				const v = e.target as HTMLVideoElement;
				if (e.isIntersecting && !reduce.matches) {
					v.play().catch(() => {});
				} else v.pause();
			}
		},
		{ threshold: 0.35 },
	);
	for (const v of videos) io.observe(v);
}

function fit(frame: HTMLIFrameElement): void {
	try {
		const doc = frame.contentDocument;
		if (!doc) return;
		const size = () => {
			const h = Math.max(
				doc.documentElement.scrollHeight,
				doc.body?.scrollHeight ?? 0,
			);
			if (h > 0) frame.style.height = `${h}px`;
		};
		size();
		new ResizeObserver(size).observe(doc.documentElement);
	} catch {
		// Cross-origin (never, the figure is same-origin): keep the CSS height.
	}
}

function figures(): void {
	const frames = document.querySelectorAll<HTMLIFrameElement>(
		"[data-figure] iframe[data-src]",
	);
	const load = (f: HTMLIFrameElement) => {
		if (f.src) return;
		f.addEventListener("load", () => {
			f.closest("[data-figure]")?.classList.add("ready");
			fit(f);
		});
		f.src = (light.matches && f.dataset.srcLight) || f.dataset.src || "";
	};
	if (!("IntersectionObserver" in window)) {
		for (const f of frames) load(f);
		return;
	}
	const io = new IntersectionObserver(
		(entries) => {
			for (const e of entries)
				if (e.isIntersecting) {
					load(e.target as HTMLIFrameElement);
					io.unobserve(e.target);
				}
		},
		{ rootMargin: "600px 0px" },
	);
	for (const f of frames) io.observe(f);
	light.addEventListener("change", () => {
		for (const f of frames) {
			if (!f.src) continue;
			const want = (light.matches && f.dataset.srcLight) || f.dataset.src;
			if (want && !f.src.endsWith(want)) f.src = want;
		}
	});
}

clips();
figures();

export {};
